import { makeStyles } from '@material-ui/core/styles'

const styles = theme => ({
  customDomain__root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  displayF: {
    display: 'flex',
  },
  customDomain__headerWithIcon: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },

  customDomain__icon: {
    marginRight: '5px',
    width: '20px',
    height: '20px',
    marginTop: '3px',
  },
  customDomain__domainView: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#F4F6F8',
    borderRadius: '8px',
    height: '53px',
    padding: '16px',
  },
  customDomain__cname: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 8,
  },
  customDomain__addDomainButton: {
    backgroundColor: '#37D768',
    color: '#fff',
    borderRadius: '12px',
    width: '116px',
    border: 'none',
    boxShadow: 'none',
    height: '40px',
    '&:hover': {
      backgroundColor: '#37D768',
    },
  },
  customDomain__buttonDiv: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  customDomain__cnameList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    backgroundColor: '#F4F6F8',
    borderRadius: '8px',
    marginTop: '32px',
    padding: '12px 16px',
  },
  customDomain__headerList: {
    padding: '0px 16px',
  },
  customDomain__list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: '16px',
    backgroundColor: '#fff',
    borderRadius: '8px',
  },
  customDomain__listItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  card: {
    maxWidth: 700,
    maxHeigh: 600,
    alignItems: 'center',
    boxShadow: 'none',
    borderRadius: '16px',
    backgroundColor: '#F4F6F8',
    padding: '24px 16px',
  },
  textField: {
    width: 300,
  },
  button: {
    backgroundColor: 'rgba(0, 171, 85, 0.08)',
    color: '#00AB55',
    marginLeft: '40%',
    margin: '25px 0 15px 0',
  },
  next: {
    marginTop: theme.spacing(2),
  },
  input: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(1.5),
  },
  inputWrapper: {
    borderColor: '#d6d6d6',
  },
  childGrid: {
    marginBottom: theme.spacing(1.5),
  },
  limitModalImage: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: '20px',
  },
  certificationContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
  },
  title: {
    fontSize: '18px',
    fontWeight: 500,
    padding: '8px 0px',
  },
  description: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#637381',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
  },
  bannerContainer: {
    maxWidth: '840px',
    width: '100%',
    height: '260px',
    borderRadius: '16px',
    border: '1px solid #E0E0E0',
    display: 'flex',
    flexDirection: 'row',
    backgroundImage: `url('/assets/banner-custom-domain.png')`,
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      height: '220px',
      backgroundSize: 'contain',
    },
    [theme.breakpoints.down('sm')]: {
      height: '200px',
      flexDirection: 'column',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      height: '180px',
      borderRadius: '12px',
    },
  },
  bannerContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'left',
    width: '360px',
    height: '260px',
    gap: '16px',
    textAlign: 'center',
    marginLeft: '50px',
    [theme.breakpoints.down('md')]: {
      width: '320px',
      height: '220px',
      marginLeft: '40px',
      gap: '12px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto',
      marginLeft: '0',
      padding: '20px',
      alignItems: 'center',
      textAlign: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '16px',
      gap: '10px',
    },
  },
  bannerText: {
    color: '#002E47',
    fontWeight: 500,
    fontSize: '18px',
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      textAlign: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
    },
  },
  bannerSubText: {
    color: '#637381',
    fontSize: '14px',
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      fontSize: '13px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
      textAlign: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
  },
})

export default styles
